export default __webpack_public_path__ + "static/media/ic_draw.2fc28b10.svg";